import { RoleEnum } from '../interfaces/permission.interface';
import { StorageService } from '../services/storage.service';

export const SYSTEM_SUPER_ADMIN_HOME = '/admin/setting/organisations';

function parseJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const segment = token.split('.')[1];
    if (!segment) return null;
    return JSON.parse(atob(segment)) as Record<string, unknown>;
  } catch {
    return null;
  }
}

function normalizeRoleNames(raw: unknown): string[] {
  if (raw == null) return [];
  if (Array.isArray(raw)) {
    return raw.map((item) => `${item}`.trim()).filter(Boolean);
  }
  if (typeof raw === 'string') {
    return raw
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean);
  }
  return [];
}

function roleIsSuperAdmin(role: string): boolean {
  const normalized = role.toUpperCase().replace(/^ROLE_/, '');
  return normalized === RoleEnum.SUPER_ADMIN;
}

export function getRolesFromAuthToken(storage: StorageService): string[] {
  const token = storage.getAuthToken();
  if (!token) return [];

  const payload = parseJwtPayload(token);
  if (payload) {
    const fromPayload = [
      ...normalizeRoleNames(payload['roles']),
      ...normalizeRoleNames(payload['authorities']),
      ...normalizeRoleNames(payload['role']),
    ];
    if (fromPayload.length) {
      return fromPayload;
    }
  }

  try {
    const detail = storage.getDetailFromToken() as { roles?: string[] };
    return detail.roles ?? [];
  } catch {
    return [];
  }
}

export function isSystemSuperAdminFromToken(
  storage: StorageService,
): boolean {
  return getRolesFromAuthToken(storage).some(roleIsSuperAdmin);
}
